export default "__VITE_ASSET__BdjTDC3g__"